<template>
    <div>
          <div class="card" style="width:500px;height:250px;margin:0 auto;margin-top:150px;box-shadow: 10px 10px 5px #888888;">
               <div class="card-header" style="font-weight:bold;line-height:20px;">
                  用户密码修改
                  <span class="float-right" style="display:block;width:20px;line-height:20px;text-align:center;font-size:20px;" @click="$router.go(-1)">
                           &times;
                  </span>
               </div>
              <div class="card-body">
                   <table>
                        <tr>
                            <td>
                                旧密码<span style="color:red">*</span>：
                            </td>
                            <td>
                                <input class="form-control mb-1" v-model="oldPwd" type="text">
                            </td>
                        </tr>
                        <tr>
                            <td>
                                 新密码<span style="color:red">*</span>：
                            </td>
                            <td>
                             <input class="form-control mb-1" v-model="newPwd1" type="text">
                            </td>
                        </tr>
                        <tr>
                            <td>
                                重复新密码<span style="color:red">*</span>：
                            </td>
                            <td>
                              <input class="form-control" v-model="newPwd2" type="text">
                            </td>
                        </tr>
                   </table>
                   <p class="text-center">
                         <button class="btn btn-primary mt-3" @click="changePassword()">
                            确认修改密码
                        </button>
                   </p>
              </div>
          </div>
    </div>
</template>
<script>
export default {
      data(){
          return {
              username:'',
              oldPwd:'',
              newPwd1:'',
              newPwd2:'',
          }
      },
      methods:{
      changePassword: async function () {
           if(this.oldPwd==""||this.newPwd1==""||this.newPwd2==""){
                alert("请输入密码")
           }
          else if(this.newPwd2.length<8){
                 alert("新密码不能少于8位")
              }
          else if(this.newPwd1!==this.newPwd2){
               alert("新密码两次输入不一样")
          }
          else{
              const {data: res} = await this.$http.post('Dls/getFun', {
                action:'ClerkChangePwd',
                obj: JSON.stringify({
                    username:window.sessionStorage.getItem('username'),
                    oldPwd:this.oldPwd,
                    newPwd1:this.newPwd1,
                    newPwd2:this.newPwd2,
                })
              })
               
              if (res.data.isok) {
                    alert(res.data.msg)
                    this.$router.push({path: '/index' })
                
              }else{
                  alert(res.data.msg)
              }
          }
      },
      }
}
</script>
<style scoped> 
    

</style>



// WEBPACK FOOTER //
// src/components/password.vue